import { PropsWithChildren } from 'react';
import { Divider, Stack, StackProps, styled } from '@mui/material';
import { WithTheme } from '@issuemanager/apps/client/theme';

type Props = PropsWithChildren & StackProps;

const StyledStack = styled(Stack)<WithTheme<StackProps>>`
  gap: ${({ theme }) => theme.spacing(4)};
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
`;

export function ReadonlyStack(props: Props) {
  const { children, ...stackProps } = props;

  return (
    <StyledStack
      divider={<Divider orientation='vertical' flexItem />}
      {...stackProps}
    >
      {children}
    </StyledStack>
  );
}
